import { API_URL } from "@/helpers";
import axios from "axios";
import { fetch } from "@/helpers";
import { SURVEY_TYPE } from "@/const";
export const surveyService = {
  getControlled,
  getCoordinates,
  getSurveyDraft,
  getSurveys,
  getAirportSurveys,
  getAirportDailySurveys,
  saveSurveyDraftStepOne,
  saveSurveyDraftStepTwo,
  saveSurveyDraftStepThree,
  saveSurveyDraftMapImage,
  submitSurveyDraft,
  saveFlightLogs,
  saveEvent,
  getSMS,
  ackSMS,
  deleteMission,
  generateMissionReport,
  setLiveStreaming,
  getSurveyGeoData,
  getAirportIfApplicable
};

export function getControlled(longitude, latitude, isMAAC) {
  return axios.get(
    `${API_URL}/1/surveys/draft/${isMAAC ? 'modelControlled' : 'controlled'}/${longitude}/${latitude}`
  );
}

export function getCoordinates(query) {
  return axios.get(`${API_URL}/1/surveys/coordinates/${query}`);
}

export function getSurveyDraft() {
  return axios.get(`${API_URL}/1/surveys/draft/`);
}

export function getSurveys({
  type,
  currentPage,
  perPage,
  keywords,
  beginTime,
  endTime
}) {
  return axios.get(`${API_URL}/2/surveys/page/${type}`, {
    params: {
      current_page: currentPage,
      per_page: perPage,
      keywords,
      begin_time: beginTime ? new Date(beginTime).toISOString() : undefined,
      end_time: endTime ? new Date(endTime).toISOString() : undefined
    }
  });
}

export function getAirportSurveys({
  airportId,
  type,
  currentPage,
  perPage,
  keywords
}) {
  return axios.get(`${API_URL}/3/airports/missions/page/${type}/${airportId}`, {
    params: {
      current_page: currentPage,
      per_page: perPage,
      keywords: keywords
    }
  });
}

export function getAirportDailySurveys(airportId, startDate, endDate) {
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 999);
  return axios.get(
    `${API_URL}/1/airports/dailymissions/${airportId}/${startDate.toISOString()}/${endDate.toISOString()}`
  );
}

export function getSurveyGeoData() {
  return axios.get(`${API_URL}/1/surveys/surveygeodata/`);
}

export function saveSurveyDraftStepOne(
  isNew,
  {
    projectname,
    manufacturer,
    rpas,
    droneregistrationnumber,
    dronecolor,
    serialno,
    pilotname,
    pilotemail,
    pilotphone,
    pilotlicense,
    observername,
    payloadoperatorname,
    operationradius,
    radiusunit,
    operationaltitude,
    clientName,
    clientEmail,
    flightSchool,
    surveyType
  }
) {
  var flag = isNew ? "new" : "update";
  return axios.post(`${API_URL}/1/surveys/draft/${flag}/`, {
    projectname,
    manufacturer,
    rpas,
    droneregistrationnumber,
    dronecolor,
    serialno,
    pilotname,
    pilotemail,
    pilotphone,
    pilotlicense,
    observername,
    payloadoperatorname,
    operationradius,
    radiusunit,
    operationaltitude,
    ...(surveyType === SURVEY_TYPE.REVIEWER && {
      survey_type: surveyType,
      flight_school: flightSchool,
      customer_name: clientName,
      customer_email: clientEmail
    })
  });
}

export function saveSurveyDraftStepTwo(payload) {
  return axios.post(
    `${API_URL}/1/surveys/draft/update/`,
    (({ controlled, longitude, latitude, address, map_img }) => ({
      controlled,
      longitude,
      latitude,
      address,
      map_img
    }))(payload)
  );
}

export function updatePermissionStatus(type, { id, permission }) {
  return fetch.post(`${API_URL}/2/surveys/${type}/permissionUpdate`, {
    permission,
    id
  });
}

export function flightReviewRubricUpdate(
  type,
  { id, flightReviewRubricData, fileType, clientEmail, flightReviewRubricUrl }
) {
  return fetch
    .post(`${API_URL}/2/surveys/${type}/flightReviewRubricUpdate`, {
      id,
      flightReviewRubricData,
      fileType,
      clientEmail,
      flightReviewRubricUrl
    })
    .then(res => JSON.parse(res.data.data));
}

export function deleteFlightReviewRubric(
  type,
  { id, flightReviewRubricUrl }
) {
  return fetch
    .post(`${API_URL}/2/surveys/${type}/deleteFlightReviewRubric`, {
      id,
      flightReviewRubricUrl
    })
}

export function saveSurveyDraftStepThree(events) {
  return axios.post(`${API_URL}/1/surveys/draft/update/`, {
    events: events
  });
}

export function saveSurveyDraftMapImage(payload) {
  return axios.post(
    `${API_URL}/1/surveys/draft/mapimage/`,
    (({ mapImageData, map_img }) => ({
      mapImageData,
      map_img
    }))(payload)
  );
}

export function submitSurveyDraft() {
  return axios.post(`${API_URL}/1/surveys/draft/submit/`);
}

export function saveFlightLogs(flightlogs) {
  return axios.post(`${API_URL}/1/surveys/saveFlightLogs/`, {
    flightlogs: flightlogs
  });
}

export function saveEvent(event) {
  return axios.post(
    `${API_URL}/1/surveys/saveEvent/`,
    (({ start, end, newStart, newEnd, startLocal, endLocal }) => ({
      start,
      end,
      newStart,
      newEnd,
      startLocal,
      endLocal
    }))(event)
  );
}

export function getSMS() {
  return axios.get(`${API_URL}/1/surveys/sms/`);
}

export function ackSMS(id) {
  return axios.get(`${API_URL}/1/surveys/sms/ack/${id}/`);
}

export function deleteMission(event) {
  return axios.post(
    `${API_URL}/1/surveys/deleteMission/`,
    (({ status, email, start, end }) => ({
      status,
      email,
      start,
      end
    }))(event)
  );
}

export function generateMissionReport(event) {
  return axios.post(
    `${API_URL}/1/surveys/generateMissionReport/`,
    (({ license, start, end }) => ({
      license,
      start,
      end
    }))(event)
  );
}

export function setLiveStreaming(event) {
  return axios.post(
    `${API_URL}/1/surveys/liveStreaming/`,
    (({ license, channel_id, start, streaming }) => ({
      license,
      channel_id,
      start,
      streaming
    }))(event)
  );
}

export function getAirportIfApplicable() {
  return axios.get(`${API_URL}/1/surveys/draft/airport/`);
}

export function getallpartners() {
  return fetch.get("/1/airports/getallpartners/").then(res =>
    JSON.parse(res.data).reduce((acc, cur) => {
      acc[cur.code] = cur;
      return acc;
    }, {})
  );
}
